import { atom } from "jotai";

export const tokenAtom = atom(localStorage.getItem("token"));

export const accountAtom = atom(null);
